// extracted by mini-css-extract-plugin
export var filterIncDec = "_4w-0";
export var leftBorder = "_4w-1";
export var rightBorder = "_4w-2";
export var stringInput = "_4w-3";